import React from 'react'

import LoadingOverlay from 'components/LoadingOverlay'

const SplashScreen = () => {
  return <LoadingOverlay />
}

export default SplashScreen
